import type { Load } from "@sveltejs/kit";
import { initStoryblok } from "../../storyblok";
import { identifyUserFromCookie, initPostHogFromEnv } from "../../utils";
import type { LayoutServerResponse } from "./server";
import { browser } from "$app/environment";

let initialized = false;

export const load: Load<{}, LayoutServerResponse, {}, LayoutServerResponse, 'layout'> = async ({ url, data }) => {
  // Only run once for SSR and SPA
  if (!initialized) {
    console.log(`[routes/+layout.ts] initializing storyblok and posthog for ${browser ? 'client' : 'server'}`);
    await Promise.allSettled([initStoryblok(), initPostHogFromEnv()]);

    if (browser) {
      console.log('[routes/+layout.ts] identifying user with posthog');
      // Identify user with PostHog using the __agapi_identifier cookie
      identifyUserFromCookie();
    }

    initialized = true;
  }

  return data;
};
